module.exports = __webpack_public_path__ + "static/img/icon06.85105f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/image/index/icon06.png
// module id = EUiT
// module chunks = 1